import { z } from "zod";

export const JiraProject = z.object({
  key: z.string(),
  name: z.string().default(""),
  id: z.string().default(""),
  project_type: z.string().default(""),
});

export const JiraEffectiveConfig = z.object({
  configured: z.boolean(),
  project_id: z.number().int().nullish(),
  config_id: z.number().int().nullish(),
  base_url: z.string().default(""),
  project_key: z.string().default(""),
  needs_project: z.boolean().default(false),
  default_issue_type: z.string().default(""),
  allow_for_passed: z.boolean().default(false),
  dedup_enabled: z.boolean().default(false),
});

export const JiraConfig = z.object({
  id: z.number().int(),
  client_id: z.number().int(),
  project_id: z.number().int().nullish(),
  project_key: z.string(),
  enabled: z.boolean(),
  use_client_settings: z.boolean(),
  base_url: z.string(),
  cloud_id: z.string().default(""),
  api_base_url: z.string().default(""),
  auth_email: z.string(),
  default_issue_type: z.string(),
  issue_type_map: z.record(z.string()),
  default_priority: z.string(),
  priority_map: z.record(z.string()),
  labels: z.string().array(),
  attach_screenshots: z.boolean(),
  attach_video: z.boolean(),
  video_as_link: z.boolean(),
  attach_logs: z.boolean(),
  max_attachment_bytes: z.number().int(),
  send_environment: z.boolean().default(false),
  extra_fields: z.record(z.unknown()).default({}),
  dedup_enabled: z.boolean(),
  allow_for_passed: z.boolean(),
  has_api_token: z.boolean(),
  is_ready: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const JiraTeamConfigCreate = z.object({
  project_id: z.null().optional(),
  base_url: z.string(),
  auth_email: z.string(),
  api_token: z.string(),
  enabled: z.boolean(),
});

export const JiraTeamConfigUpdate = JiraTeamConfigCreate.omit({ project_id: true }).partial().extend({
  cloud_id: z.string().optional(),
});

export const JiraProjectConfigCreate = z.object({
  project_id: z.number().int().positive(),
  enabled: z.boolean().optional(),
  use_client_settings: z.literal(true),
  project_key: z.string().trim().min(1),
});

export const JiraConfigCreate = z.union([JiraTeamConfigCreate, JiraProjectConfigCreate]);

export type JiraConfigValue = z.infer<typeof JiraConfig>;

export type JiraProjectValue = z.infer<typeof JiraProject>;
export type JiraEffectiveConfigValue = z.infer<typeof JiraEffectiveConfig>;
